import { useAppDispatch } from '../../store';
import { setQR, setQRMenuIds } from '../../features/cart/cart';
import {
  fetchQRCodeAddress,
  setCategorizedView,
  setMenusOnly,
  setQRAddress,
  setQRCodeOrderingStatus,
} from '../../features/restaurant/restaurant';

/* eslint-disable */

type Dispatch = ReturnType<typeof useAppDispatch>;

/**
 * Client-side-navigation counterpart to the qr/menu_ids/ordering_enabled/categorized_view/
 * menus_only/address_id parsing that `src/app/App/index.tsx`'s bootstrap effect does on a
 * full page load. That effect only ever runs once per mount ([] deps), so navigating between
 * catalogs via the "Explore" drawer (react-router `navigate()`, no remount) needs to apply
 * those same params itself -- otherwise `state.cart.qr_code`/`qr_code_menu_ids` and
 * `state.restaurant.qr_ordering_enabled` would keep pointing at the catalog the guest just
 * left, breaking both the menu_ids filter (Menus list) and the ordering_enabled view-only
 * gate (MenuDish/MenuItemCard) for the catalog just navigated into.
 *
 * Deliberately mirrors only the params a linked-catalog `guest_url` (or a stored nav-stack
 * node's url) can carry -- never touches order_type/table_number, which belong to the
 * guest's root ordering session and must survive exploring linked catalogs untouched.
 */
export function applyLinkedCatalogParams(dispatch: Dispatch, url: URL) {
  const params = url.searchParams;
  const qr = params.get('qr');
  if (qr === null) {
    return;
  }

  if (params.get('ordering_enabled') !== null) {
    dispatch(
      setQRCodeOrderingStatus({
        [qr]:
          params.get('ordering_enabled') === 'True' ||
          params.get('ordering_enabled') === 'true',
      }),
    );
  } else {
    dispatch(setQRCodeOrderingStatus({ [qr]: true }));
  }

  const menu_ids = params.getAll('menu_ids').map(v => parseInt(v));
  dispatch(setQRMenuIds({ [qr]: menu_ids }));
  dispatch(setQR(qr));

  dispatch(
    setCategorizedView(
      params.get('categorized_view') === 'True' ||
        params.get('categorized_view') === 'true',
    ),
  );
  dispatch(
    setMenusOnly(
      params.get('menus_only') === 'True' ||
        params.get('menus_only') === 'true',
    ),
  );

  const addressId = params.get('address_id');
  const r_id = params.get('r_id');
  if (addressId && !isNaN(parseInt(addressId)) && r_id) {
    dispatch(fetchQRCodeAddress(parseInt(r_id), parseInt(addressId)));
  } else {
    dispatch(setQRAddress(null));
  }
}
